import React, { Component } from 'react';

import ProgramHighlight from '@tvguide/components/programhighlight';
import AppBanner from '@tvguide/components/appbanner';
import Toolbar from '@tvguide/components/toolbar';
import DateTimeline from '@tvguide/components/datetimeline';
import GridView from '@tvguide/components/gridview';
import ListView from '@tvguide/components/listview';
import TextView from '@tvguide/components/textview';
import DetailPanel from '@tvguide/components/detailpanel';
import LoadingPopup from '@tvguide/components/loadingpopup';
import FixedScroll from '@tvguide/components/fixedScroll';
import DarkModeToggle from '../darkmodeToggle';

export default class App extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props
      .getChannels(this.props.nid)
      .then(
        (() => {
          this.props.getDayProgram(this.props.nid);
        }).bind(this),
      )
      .catch(error => {
        console.error(error);
      });
  }

  render() {
    return (
      <div className="fv-tvguide">
        <ProgramHighlight />
        <AppBanner />
        <FixedScroll isSticky={this.props.view}>
          <DarkModeToggle />
          <Toolbar view={this.props.view} />
          <DateTimeline view={this.props.view} />
        </FixedScroll>
        {!this.props.isLoaded && <div className="fv-loading" />}
        <DetailPanel />
        {this.props.isLoaded && this.props.view === 'grid' && <GridView />}
        {this.props.isLoaded && this.props.view === 'list' && <ListView />}
        {this.props.isLoaded && this.props.view === 'text' && <TextView />}
        <LoadingPopup />
      </div>
    );
  }
}
